// extracted by mini-css-extract-plugin
module.exports = {"paymentCard":"styles_paymentCard__tfwTj","title":"styles_title__3fx8u","price":"styles_price__hkyhH","actionButton":"styles_actionButton__10MCh"};